import styled from '@emotion/styled';

export const Container = styled.div`
  flex: 1;
  overflow: auto;
`;
